import { useState } from "react";
import "./style.scss";
import data from "../../../pages/Sitemap/links.json";
import { useMediaQuery } from "customHooks/useMediaQuery";
import cityLinks from "./quick_links.json";
import { ReactComponent as Arrow } from "../../../assets/icons/svg/arrow-right-white.svg";
import footerLinks from "./footerlinks.json";

// const locations = [
// 	"Goa",
// 	"South Goa",
// 	"North Goa",
// 	"Lonavala",
// 	"Alibaug",
// 	"Karjat",
// 	"Igatpuri",
// 	"Mahabaleshwar",
// 	"Mumbai",
// 	"Nashik",
// 	"Pune",
// 	"Panchgani",
// 	"Pawna",
// 	"Wada",
// 	"Mulshi",
// 	"Panvel",
// 	"Uttan",
// 	"Kashid",
// 	"Kamshet",
// 	"Khopoli",
// 	"Khandala",
// 	"Palghar",
// 	"Matheran",
// 	"Murbad",
// 	"Lavasa",
// 	"Dahanu",
// 	"Pali",
// 	"Kanhe",
// 	"Nagpur",
// 	"Bangalore",
// 	"Sakleshpur",
// 	"Gokarna",
// 	"Dandeli",
// 	"Kudremukh",
// 	"Kushalnagar",
// 	"Bandipur",
// 	"Thirthahalli",
// 	"Kabini",
// 	"Virajpet",
// 	"Kunnur",
// 	"Nandi Hills",
// 	"Badami",
// 	"Jog Falls",
// 	"Manipal",
// 	"Karwar",
// 	"Malpe",
// 	"Coorg",
// 	"Chikmagalur",
// 	"Mysore",
// ];

const SEOFooter = () => {
	const options = [
		"Villas",
		"Homestays",
		"Cottages",
		"Luxury Villas",
		"Pool Villas",
		"Bunglows",
	];
	const [select, setSelect] = useState("Villas");

	const locations = Object.values(data)
		.flat()
		.map((e) => e.title);

	const [viewMore, setViewMore] = useState(true);

	const [selectState, setSelectState] = useState(cityLinks[0].STATE);
	const width = useMediaQuery();
	if (width < 900) {
		return (
			<>
				<div className="seo-footer-wrapper">
					{options.map((op) => (
						<details className="seo-footer-selector">
							<summary>
								<div className="seo-footer-options">{op}</div>
							</summary>

							<ul className={viewMore ? `seo-view-more` : ""}>
								{locations.map((e) => {
									if (op === "Homestays") {
										return (
											<li>
												<a
													href={"/homestays/homestays-in-" + e}
													target="_blank"
												>
													Homestays in {e}
												</a>
											</li>
										);
									}
									if (op === "Cottages") {
										return (
											<li>
												<a href={"/villas/villas-in-" + e} target="_blank">
													Cottages in {e}
												</a>
											</li>
										);
									}
									if (op === "Pool Villas") {
										return (
											<li>
												<a
													href={"/villas/villas-in-" + e + "?amenities=28"}
													target="_blank"
												>
													Pool Villas in {e}
												</a>
											</li>
										);
									}
									if (op === "Luxury Villas") {
										return (
											<li>
												<a
													href={"/villas/villas-in-" + e + "?signature=true"}
													target="_blank"
												>
													Luxury Villas in {e}
												</a>
											</li>
										);
									}
									if (op === "Bunglows") {
										return (
											<li>
												<a href={"/villas/villas-in-" + e} target="_blank">
													Bunglows Villas in {e}
												</a>
											</li>
										);
									}
									return (
										<li>
											<a href={"/villas/villas-in-" + e} target="_blank">
												Villas in {e}
											</a>
										</li>
									);
								})}
							</ul>
							<button
								onClick={() => {
									setViewMore(!viewMore);
								}}
							>
								{!viewMore ? "Show Less" : "Show More"}
							</button>
						</details>
					))}
					<details className="seo-footer-selector">
						<summary>
							<div className="seo-footer-options">Travel Guide</div>
						</summary>
						<div
							style={{
								display: "flex",
								gap: 32,
							}}
						>
							<div className="seo-external-links">
								<div className="seo-title-button">States</div>
								{cityLinks.map((e) => {
									return (
										<div
											className={`seo-state-links ${
												e.STATE === selectState && "active-state-link"
											}`}
											onClick={() => {
												setSelectState(e.STATE);
											}}
										>
											{e.STATE} {e.STATE === selectState && <Arrow />}
										</div>
									);
								})}
							</div>
							<div className="seo-external-links">
								<div className="seo-title-button">Cities</div>
								{cityLinks.map((e) => {
									return (
										<>
											{e.top_locations.split(", ").map((loc) => {
												return (
													<>
														<details
															style={{
																display:
																	e.STATE === selectState ? "block" : "none",
															}}
														>
															<summary>{loc}</summary>
															<p
																style={{
																	display: "flex",
																	flexDirection: "column",
																	gap: 4,
																}}
															>
																{[
																	"Places to Visit",
																	"Things To Do",
																	"Nearby Restaurants",
																	"How To Reach",
																	"Best Time To Visit",
																].map((t) => {
																	return (
																		<a
																			target="_blank"
																			className="seo-links"
																			href={`/location/${t
																				.toLowerCase()
																				.replaceAll(" ", "-")}/${t
																				.toLowerCase()
																				.replaceAll(" ", "-")}-${loc}`}
																		>
																			{t}
																		</a>
																	);
																})}
															</p>
														</details>
													</>
												);
											})}
										</>
									);
								})}
							</div>
						</div>
					</details>

					{footerLinks.map((ele) => {
						return (
							<details className="seo-footer-selector">
								<summary>
									<div className="seo-footer-options">{ele?.column}</div>
								</summary>
								<ul>
									{ele?.links?.map((elem, index) => {
										return (
											<li>
												<a
													className="seo-links"
													href={ele?.slugs[index]}
													target="_blank"
												>
													{elem}
												</a>
											</li>
										);
									})}
								</ul>
							</details>
						);
					})}
				</div>
			</>
		);
	}

	return (
		<div className="seo-footer-wrapper">
			<div className="seo-footer-selector">
				{options.map((e) => {
					return (
						<div
							className={`seo-footer-options ${
								e === select ? "seo-active-option" : ""
							}`}
							onClick={() => {
								setSelect(e);
							}}
						>
							{e}
						</div>
					);
				})}
			</div>
			<ul className={viewMore ? `seo-view-more` : ""}>
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Villas" ? "block" : "none",
							}}
						>
							<a href={"/villas/villas-in-" + e} target="_blank">
								Villas in {e}
							</a>
						</li>
					);
				})}
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Homestays" ? "block" : "none",
							}}
						>
							<a target="_blank" href={"/homestays/homestays-in-" + e}>
								Homestays in {e}
							</a>
						</li>
					);
				})}
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Cottages" ? "block" : "none",
							}}
						>
							<a target="_blank" href={"/villas/villas-in-" + e}>
								Cottages in {e}
							</a>
						</li>
					);
				})}
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Pool Villas" ? "block" : "none",
							}}
						>
							<a
								target="_blank"
								href={"/villas/villas-in-" + e + "?amenities=28"}
							>
								Pool Villas in {e}
							</a>
						</li>
					);
				})}
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Luxury Villas" ? "block" : "none",
							}}
						>
							<a
								target="_blank"
								href={"/villas/villas-in-" + e + "?signature=true"}
							>
								Luxury Villas in {e}
							</a>
						</li>
					);
				})}
				{locations.map((e) => {
					return (
						<li
							style={{
								display: select === "Bunglows" ? "block" : "none",
							}}
						>
							<a target="_blank" href={"/villas/villas-in-" + e}>
								Bunglows Villas in {e}
							</a>
						</li>
					);
				})}
			</ul>
			<button
				onClick={() => {
					setViewMore(!viewMore);
				}}
			>
				{!viewMore ? "Show Less" : "Show More"}
			</button>
		</div>
	);
};

export default SEOFooter;
